import React from 'react'

import './geramosresultados.css'

const GeramosResultados = () => {
  return (
    <div className='lsk__geramosresultados'>
        <div className='lsk__geramosresultados-background'>
            <div className='lsk__geramosresultados-frase'>
              <h1>Com a nossa experiência</h1>
              <h1>Exponencializamos Resultados</h1>
            </div>
        </div>
    </div>
  )
}

export default GeramosResultados